// GENERATED from app.config.json by `appfactory sync`. Do not hand-edit —
// change app.config.json and re-run, or your edit is lost on the next sync.

// ============================================================================
//  Deployment origin
// ----------------------------------------------------------------------------
//  The public HTTPS origin this app is served from. No trailing slash.
//
//  The WEB build never needs it — location.origin is already correct there.
//  It exists for NATIVE builds, where location.origin is capacitor://localhost
//  (iOS) or https://localhost (Android):
//
//    * /api/… fetches would resolve to the app bundle instead of the server;
//    * shared links would come out as capacitor://localhost/…, which no
//      recipient can open.
// ============================================================================

export const PUBLIC_ORIGIN = "https://switchonchristmas.jeremymarks.com.au";

// From app.slug. Used to namespace Live Update storage so apps that share a
// GCS bucket (or a mistaken PUBLIC_ORIGIN) cannot overwrite each other's OTA
// manifests — without this, publishing one app to production-ios-N silently
// becomes the bundle a sibling downloads next.
// The app's own name and tagline, so the chassis can use them without a
// component importing app.config.json — which the browser cannot read.
export const APP_NAME = "Switch On Christmas";
export const APP_SHORT_NAME = "Switch On Christmas";
export const APP_TAGLINE = "One spark. A whole street of Christmas moments.";

export const APP_SLUG = "switch-on-christmas";

// ============================================================================
//  Native identity — deep links
// ----------------------------------------------------------------------------
//  server.js serves the two association files from these:
//    /.well-known/apple-app-site-association  (iOS Universal Links)
//    /.well-known/assetlinks.json             (Android App Links)
//
//  Without them a shared link opens in the browser instead of the app, even
//  when the app is installed.
// ============================================================================

// <Apple Team ID>.<bundle id>. Empty until you set apple.teamId — server.js
// returns 404 for the association file while it is, rather than serving one
// that looks configured and can never verify.
export const IOS_APP_ID = "K28BNW6KB7.com.harfredlabs.switchonchristmas";

// The App Clip is a SEPARATE app id and must be listed in the AASA `appclips`
// block, or a tapped link can never launch the clip. Blank when there is no clip.
export const IOS_APPCLIP_APP_ID = "";

export const ANDROID_PACKAGE = "com.harfredlabs.switchonchristmas";

// Paths this app claims for deep linking, derived from app.config.json plus any
// enabled addon. server.js builds the AASA components from this, so enabling an
// addon that adds a route needs no edit to server.js at all.
export const DEEP_LINKS = ["/open","/c","/c/","/day","/day/"];

// Extra Content-Security-Policy hosts required by the enabled addons, merged
// from each addon's own manifest. Derived, never hand-edited: an addon that
// needs a host and does not get it fails at runtime with a console error most
// people never see.
export const CSP_EXTRA = {};

// Browser features this document may use, merged over the locked-down default.
// `{"geolocation": ["self"]}` re-enables location for this origin — without it
// the browser blocks it with a policy violation rather than a prompt, which
// looks exactly like the user having said no.
export const PERMISSIONS_POLICY_EXTRA = {};

// Origins allowed to embed this app in an iframe, beyond the app itself.
// The App Factory portal's build simulator is the reason this exists; empty is
// the right value for an app nobody needs to preview. Merged into CSP
// frame-ancestors by server.js.
export const EMBED_ORIGINS = [];

// SHA-256 fingerprint of the Android RELEASE signing certificate, colon-separated
// uppercase hex.
//
// With Play App Signing this is the certificate GOOGLE re-signs with, NOT your
// local upload key — using the upload key's fingerprint is the classic way to
// get App Links that never verify. `appfactory store sync-fingerprint` reads
// the correct value back from the console after your first upload.
//
// While this is empty, server.js returns 404 for assetlinks.json rather than
// serving a file that looks configured but can never verify.
export const ANDROID_CERT_SHA256 = "";

// ============================================================================
//  Web build marker
// ----------------------------------------------------------------------------
//  Mirrors VERSION in sw.js. Native builds have no service worker, so this is
//  the only way to tell which web payload is running after an OTA update —
//  exactly where it matters most.
// ============================================================================

export const WEB_BUILD = "switch-on-christmas-ddeac742ae4b";
